// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterImages45_root__iqC8H","title":"AfterImages45_title__2KNco","images":"AfterImages45_images__dmS39"};